import { useState, useEffect, useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import ViewAllAlerts from "../../common/Components/ViewAllAlerts";
import PowerBIReportEmbed from '../PowerBIReportEmbed';
import { setPowerBiData } from '../../store/Actions';
import KPIService from '../../services/console_services/KPI';
import MapService from '../../services/console_services/Map';
import { setViewPowerBi, setScenarios, setSelectedScenariosRR, setActiveScenarios } from '../../store/Actions';
import useTabList from '../../common/TabList';
import UserDetailsServices from '../../services/console_services/LoginLogot';
import TabComponent from '../../common/Components/TabComponent';
import GraphService from '../../services/console_services/Graph';
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2.5, 2.5, 1.25, 10),
    fontFamily: theme.fontFamily,
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));

const IOF_Prioritization = ({
  tabIndex,
  Network,
  DC,
  Products,
  date,
  applyFilter,
  Division,
  PL3,
  CL6,
  Customers,
  _periodType,
  role,
  viewPowerBi,
  setViewPowerBi,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [KPIData, setKPIData] = useState({});
  const [KPILoading, setKPILoading] = useState(true);
  // const [mapData, setMapData] = useState([]);
  const mapData = [];
  // const [MapLoading, setMapLoading] = useState(false);
  const MapLoading = false;
  const dispatch = useDispatch();
  const TabList = useTabList();
  const currentTabData = useMemo(() => TabList["SLP"][tabIndex], [tabIndex]);
  const [kpiPowerBi, setKpiPowerBI] = useState('');
  const entireState = useSelector((state) => state);


  useEffect(() => {
    const fetchKPIData = async () => {
      const params = {
        name: currentTabData.value,
        Level: role,
        filter: {
          RecommendedDC: DC,
          Network,
          PL3,
          Division,
          MaterialID: Products,
          CL6,
          SoldToName: Customers,
          startDate: date[0],
          endDate: date[1],
        },
      };

      setKPILoading(true);
      KPIService.getKPI(params, instance).then(data => {
        if (data?.response) {
          setKPIData(data?.response);
        }
      })
        .catch(error => console.error('Error:', error))
        .finally(() => setKPILoading(false));
    };
    fetchKPIData();
  }, [tabIndex, role, applyFilter, DC, Network, Products, entireState?.filter?.scenarioValue, CL6, Customers]);


  const toggleViewPowerBi = (val) => {
    setKpiPowerBI(val);
    setViewPowerBi(!viewPowerBi);
    dispatch(setPowerBiData(val));
  };

  return (
    <Box className={classes.root}>
      {viewPowerBi ? (
        <PowerBIReportEmbed selectedPowerData={kpiPowerBi} />
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TabComponent
                KPIData={KPIData}
                mapData={mapData}
                tabList={TabList["SLP"]}
                MapLoading={MapLoading}
                KPILoading={KPILoading}
                Module={currentTabData.value}
                handleViewPowerBi={toggleViewPowerBi}
                graphViewTabList={TabList["SLP"][tabIndex].graphViewTabList}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  periodType: state.filter.periodType,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  CL6: state.filter.CL6,
  Customers: state.filter.Customers,
  viewPowerBi: state.viewPowerBi.viewPowerBi,
});

const mapDispatchToProps = {
  setViewPowerBi,
};


export default connect(mapStateToProps, mapDispatchToProps)(IOF_Prioritization);
